import { call, take, takeEvery } from 'redux-saga/effects';

import { getQcsSyncResources, qcsSyncCreateResource, qcsSyncUpdateResource, qcsSyncDeleteResource }
  from 'data/qcsSyncResourceSagaHelpers';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';

import { transformResponseToVehicles, transformVehicleToRequestData } from 'data/vehicles/transformers';

import * as actions from './actions';
import { getLastSyncDate } from './selectors';


// ===============================================================================================
// SAGAS functions for vehicles.  These are the functions responsible for communicating directly
// with external endpoints asynchronously.

// ====================================================
// ACTION WATCHERS to trigger SAGAS calls

const mkResourceConfig = (successAction, failureAction) => mkQcsSyncResourceConfig({
  resourceName: 'vehicle',
  resourceBaseUrl: '/miles/vehicles',
  getLastSyncDate,

  transformResponseToResources: transformResponseToVehicles,
  transformResourceToRequestData: transformVehicleToRequestData,

  successAction,
  failureAction,
});

export function* getVehiclesActionWatcher() {
  // using a vanilla saga pattern so we only process a single get request
  //   - takeEvery would process every request
  //   - takeLatest would cancel any current request and start request again
  while (true) {
    const action = yield take(actions.getVehicles);

    const config = mkResourceConfig(actions.getVehiclesSuccess, actions.getVehiclesFailure);
    yield call(getQcsSyncResources, config, action);
  }
}

export function* createVehicleActionWatcher() {
  const config = mkResourceConfig(actions.createVehicleSuccess, actions.createVehicleFailure);
  yield takeEvery(actions.createVehicle, qcsSyncCreateResource, config);
}

export function* updateVehicleActionWatcher() {
  const config = mkResourceConfig(actions.updateVehicleSuccess, actions.updateVehicleFailure);
  yield takeEvery(actions.updateVehicle, qcsSyncUpdateResource, config);
}

export function* deleteVehicleActionWatcher() {
  const config = mkResourceConfig(actions.deleteVehicleSuccess, actions.deleteVehicleFailure);
  yield takeEvery(actions.deleteVehicle, qcsSyncDeleteResource, config);
}

// ====================================================
// EXPORTS

export default [
  getVehiclesActionWatcher,
  createVehicleActionWatcher,
  updateVehicleActionWatcher,
  deleteVehicleActionWatcher,
];
